import Link from 'next/link'
import * as React from 'react'

import { ResolvedAvatarImage } from '@/components/common/resolved-media-image'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card'

import { hideEmail } from '@/utils/hidden-email'

import { UserAuth } from '@/types/user.type'

interface UserAvatarPopoverProps {
  user: UserAuth
  showMessageIcon?: boolean
  onMessageClick?: (user: UserAuth) => void
}

export const UserAvatarPopover: React.FC<UserAvatarPopoverProps> = ({ user }) => {
  const userName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim() || 'User'

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div className="inline-block cursor-pointer relative">
          <Avatar className="border border-gray-200">
            <ResolvedAvatarImage avatar={user.avatar} alt={userName} />
            <AvatarFallback>{userName.charAt(0)}</AvatarFallback>
          </Avatar>
        </div>
      </HoverCardTrigger>

      <HoverCardContent side="top" align="start" className="w-full">
        <div className="flex items-center space-x-3">
          <Avatar className="h-12 w-12 border border-gray-200">
            <ResolvedAvatarImage avatar={user.avatar} alt={userName} />
            <AvatarFallback>{userName.charAt(0)}</AvatarFallback>
          </Avatar>
          <div>
            <Link href={`/user/${user.profileId || ''}`}>
              <p className="text-sm font-semibold cursor-pointer hover:underline">{userName}</p>
            </Link>
            <p className="text-xs text-gray-500">
              {hideEmail(user.email, { keepStart: 2, mask: '***', repeatToLength: true })}
            </p>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}
